<template>
  <div>
    <iframe
      allow="camera *;microphone *;"
      :src="livePushUrl"
      style="position:fixed;width:100%;height:100%;"
      frameborder="0"
      allowfullscreen="true"
      border="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'LiveOnline',
  components: {},
  data() {
    return {
      query: { id: this.$route.params.id },
      model: {},
      livePushUrl: '',
      _beforeUnload_time: '',
      _gap_time: '',
    };
  },
  created() {
    this.loadData();
  },
  destroyed() {
    window.removeEventListener('beforeunload', (e) => {
      this.beforeunloadHandler(e);
    });
  },
  mounted() {
    // 关闭窗口时更新直播状态
    window.addEventListener('beforeunload', (e) => {
      this.beforeunloadHandler(e);
    });
  },
  methods: {
    loadData() {
      this.startLive();
    },
    // 关闭页面
    beforeunloadHandler(e) {
      // 更新直播状态
      // 取消：采用回调方式
      // this.updateLiveState();

      e = e || window.event;
      if (e) {
        e.returnValue = '您是否确认离开此页面';
      }

      return '您是否确认离开此页面';
    },
    async startLive() {
      const response = await this.$api.live.startLive(this.query);
      this.model = response.data.data;
      this.livePushUrl = this.model.push_url;
    },
    async updateLiveState() {
      const response = await this.$api.live.updateLiveState({
        id: this.$route.params.id,
        stream_id: this.model.stream_id,
      });
    },
  },
};
</script>
